<div>
  <i class="material-icons me-2" aria-hidden="true">{{ iconName }}</i> <span>{{ textToShow }}</span>
</div>
